import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from 'src/app/shared/common-data-model';

@Component({
  selector: 'app-orders-assignedto-form',
  templateUrl: './orders-assignedto-form.component.html',
  styleUrls: ['./orders-assignedto-form.component.scss']
})
export class OrdersAssignedtoFormComponent implements OnInit {

  ordersDataModel = new CommonDataModel();
  assignedToChangeModelData = this.ordersDataModel.ordersAssignedToChangeModelData;
  jobsData: any;
  isFormLoading = false;
  selectedEmployee: null;
  note: string;
  employees: Array<any>;
  isJob: any;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersAssignedtoFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isJob = (this.router.url.indexOf('/quotes-list') !== -1) ? false : true;
   }

  ngOnInit() {
    this.jobsData = this.data;
    this.getEmployees();
  }

  getEmployees() {
    this.commonService.getEmployees(0).subscribe((response: any) => {
      if (response.isSuccess) {
        this.employees = response.data.filter(employee => employee.includeOnSchedule);
        this.onDefaultSelectEmployee();
      }
    });
  }

  onDefaultSelectEmployee(){
    if(this.jobsData.dataItem.inShopContactId){
      this.selectedEmployee = this.jobsData.dataItem.inShopContactId;
      this.assignedToChangeModelData.assignedTo = this.jobsData.dataItem.inShopContactId;
      this.assignedToChangeModelData.employeeName = this.jobsData.dataItem.assignedTo;
    }else{
      if(this.employees.length){
        this.selectedEmployee = this.employees[0].assignedTo;
        this.assignedToChangeModelData.assignedTo = this.employees[0].assignedTo;
        this.assignedToChangeModelData.employeeName = this.employees[0].employeeName;
      }
    }
  }

  onEmployeeChange(event: any) {
    this.assignedToChangeModelData.employeeName = event.employeeName;
  }

  onSubmit() {
    this.assignedToChangeModelData.orderId = this.jobsData.dataItem.jobId;
    this.assignedToChangeModelData.notes = this.note;
    this.assignedToChangeModelData.assignedTo = this.selectedEmployee;
    this.commonService.orderInShopAssignee(this.assignedToChangeModelData)
    .pipe(finalize(() => (this.isFormLoading = false))).subscribe((response: any) => {
      this.isFormLoading = false;
      if(response.isSuccess){
        this.toastr.success(response.errors || 'Updated successfully');
        this.dialogRef.close(true);
      }else{
        this.toastr.error(response.errors || 'Something went wrong please Re-try', 'Error!');
      }
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
